import {
  MY_JOBS,
  OTHER_JOBS,
  SORT_JOBS,
  FILTERS,
  SET_SUBMITTING,
  SET_STC_FILTER,
  SET_CC_FILTER,
  SET_DISTRIBUTOR_FILTER,
  CLEAR_FILTERS,
  SET_OFFSET,
} from '../constants/actionTypes';

const initialState = {
  myJobs: [],
  otherJobs: [],
  totalMyJobs: 0,
  totalOtherJobs: 0,
  sort: { jobDate: 'DESC' },
  offsets: {
    myJobsOffset: 0,
    otherJobsOffset: 0,
  },
  filter: {
    isSubmitting: false,
    jobDateFrom: null,
    jobDateTo: null,
    reportLevel: [],
    status: [],
    customerNumber: '',
    customerName: '',
    serviceProductNumber: '',
    materialNumber: '',
    notificationNumber: '',
    equipmentSerialNumber: '',
    distributorCode: [],
    customerCenterPlantCode: [],
    serviceTechnologyCenterPlannerGroup: [],
    failureAnalysisEngineerNotAssigned: false,
    pendingMyApproval: false,
    unreadMessages: false,
    openJobs: false,
    publishedJobs: false,
    isFirstRender: true
  },
};

const jobs = (state = initialState, action) => {
  switch (action.type) {
    case MY_JOBS:
      return {...state, myJobs: action.payload};
    case OTHER_JOBS:
      return {...state, otherJobs: action.payload};
    case SORT_JOBS:
      return {...state, sort: { jobDate: action.payload }};
    case FILTERS:
      return {...state, filter: action.payload};
    case SET_STC_FILTER:
      return {...state, filter: {...state.filter, serviceTechnologyCenterPlannerGroup: action.payload }}
    case SET_CC_FILTER:
      return {...state, filter: {...state.filter, customerCenterPlantCode: action.payload }}
    case SET_DISTRIBUTOR_FILTER:
      return { ...state, filter: { ...state.filter, distributorCode: action.payload }}
    case CLEAR_FILTERS:
      return {...state, filter: {...initialState.filter, isFirstRender: false}}
    case SET_OFFSET:
      return {...state, offsets: {...state.offsets, [action.offsetType]: action.offset}}
    case SET_SUBMITTING:
      return {...state, filter:{...state.filter, isSubmitting: action.payload}}
    default:
      return state;
  }
}

export default jobs;



// WEBPACK FOOTER //
// ./src/reducers/reducer-jobs.js